import React, { Component } from "react";
import LiveEvent from "./LiveEvent";
import chevrons from "./assets/chevrons";
import "./DayEvents.css";
import debounce from "lodash/debounce";

import { CONSTANTS } from "~/tools/date-utils";
const { LEFT, RIGHT, BOTH, NONE } = CONSTANTS;

class DayEvents extends Component {
  state = {
    scrollButtons: NONE
  };
  componentDidMount() {
    this.debouncedHandler = debounce(this.scrollButtonDisplayer, 350);
    if (this.refs.list) {
      this.scrollButtonDisplayer();
      window.addEventListener("resize", this.debouncedHandler);
      this.refs.list.addEventListener("scroll", this.debouncedHandler);
    }
  }
  componentWillUnmount() {
    if (this.refs.list) {
      window.removeEventListener("resize", this.debouncedHandler);
      this.refs.list.removeEventListener("scroll", this.debouncedHandler);
    }
  }
  handleScroll = d => e => {
    const { list } = this.refs,
      scrollDistance = Math.ceil(list.getBoundingClientRect().width * 0.8);
    list.scrollBy({
      left: d === RIGHT ? scrollDistance : -scrollDistance,
      behavior: "smooth"
    });
  };

  scrollButtonDisplayer = () => {
    const { list } = this.refs,
      clientBoxWidth = list.getBoundingClientRect().width,
      fullWidth = list.scrollWidth,
      scrollLeft = list.scrollLeft,
      isFullSize = Math.floor(clientBoxWidth) === fullWidth,
      showScrollRight = scrollLeft === 0 && !isFullSize,
      showScrollLeft =
        Math.ceil(clientBoxWidth + scrollLeft) >= fullWidth && !isFullSize,
      scrollButtons = isFullSize
        ? NONE
        : showScrollRight
          ? RIGHT
          : showScrollLeft
            ? LEFT
            : BOTH;
    this.setState({ scrollButtons });
  };
  renderChevron = d => {
    const { scrollButtons } = this.state,
      isHovered = true;
    return scrollButtons === d || scrollButtons === BOTH ? (
      <div
        className={`DayEvents_scroll scroll_${d}`}
        onClick={this.handleScroll(d)}
      >
        {chevrons[d](isHovered)}
      </div>
    ) : null;
  };
  render() {
    const { day, date, events, month } = this.props.eventsByDay;
    return (
      <div className="DayEvents">
        <div className="DayEvents_labels">
          <div className="DayEvents_dayLabel">{month}</div>
          <div className="DayEvents_dateLabel">{date}</div>
          <div className="DayEvents_dayLabel">{day}</div>
        </div>
        {events ? (
          <div className="DayEvents_list" ref="list">
            {this.renderChevron(LEFT)}
            {events.map((e, i) => (
              <LiveEvent key={i} event={e} />
            ))}
          </div>
        ) : (
          <div className="DayEvents_none">No Classes Scheduled</div>
        )}
        {events ? this.renderChevron(RIGHT) : null}
      </div>
    );
  }
}

export default DayEvents;
